<template>
<div id="top">
  <Header/>
  <Main/>
  <BnrArea/>
  <spFootMenu />
  <Footer/>
</div>
</template>
<style scoped>
 #top #head {
   position: fixed;
   top: 0;
   left: 0;
   right: 0;
   margin: auto;
   background: rgba(255,255,255,.5);
   z-index: 100;
 }
 @media (max-width: 670px) {
   #head {
    position: relative;
    top: unset;
    left: unset;
    right: unset;
    margin: auto;
    background: rgba(255,255,255,1);
    z-index: 0;
  }
 }
</style>
<script>
// @ is an alias to /src
import Header from '@/components/Header.vue'
import Main from '@/components/Home.vue'
import BnrArea from '@/components/BnrArea.vue'
import spFootMenu from "@/components/spFootMenu.vue";
import Footer from '@/components/Footer.vue'

export default {
  name: 'Top',
  components: {
    Header,Main,BnrArea,Footer,
    spFootMenu
  }
}
</script>
